export default "__VITE_ASSET__I5D4o9bN__"